module.exports = __webpack_public_path__ + "img/PT86.504965ac.png";